/**
 * Algolia Quick Search Dialog
 * Handles the header search popup dialog functionality
 */
document.addEventListener('DOMContentLoaded', function () {

});


document.addEventListener('algolia.autocomplete.afterInit', function () {
	algoliaShopify.config.show_products = true;

  const shopifyAppEmbeds = document.querySelectorAll('body > .shopify-app-block');
	const algoliaEmbed = [...shopifyAppEmbeds].find(embed => embed.querySelector('.algolia-config-money-format'));

    if (algoliaEmbed) {
        const algoliaEmbedStyles = algoliaEmbed.querySelectorAll('style');
        algoliaEmbedStyles.forEach(style => {
            style.remove();
        });
    }
});

/* ============================================================================
 * RECENT SEARCHES
 * Client-side only — nothing is sent to Algolia and no index/dashboard setup is
 * required (per https://www.algolia.com/doc/ui-libraries/autocomplete/guides/adding-recent-searches,
 * Query Suggestions is only needed when *combining* recent + suggested searches,
 * and this store already has it — it powers the Popular Searches block).
 *
 * The official createLocalStorageRecentSearchesPlugin can't be used here: the
 * Algolia app embed owns the autocomplete() call, so there is no plugins: array
 * for the theme to write to. Instead the storage helpers below mirror the
 * plugin's own storage contract (getAll / onAdd / onRemove) and feed a local
 * plugin injected via the beforeAutocompletePluginsArray hook.
 * ========================================================================== */
const RECENT_SEARCHES_KEY = 'dpd_recent_searches';
const RECENT_SEARCHES_LIMIT = 6;
const RECENT_SEARCHES_MIN_LENGTH = 2;
/* A query is only worth remembering if it found something. Gibberish returns 0 hits,
 * so this is what keeps "aslkfjaifjasjfiea" out of the list. Raise it to discard
 * near-misses too, at the cost of also discarding exact product/SKU searches. */
const RECENT_SEARCHES_MIN_HITS = 1;

/** getAll — never throws; corrupt or blocked storage reads as "no history". */
function readRecentSearches() {
	try {
		const raw = window.localStorage.getItem(RECENT_SEARCHES_KEY);
		if (!raw) return [];
		const parsed = JSON.parse(raw);
		if (!Array.isArray(parsed)) return [];
		return parsed.filter((entry) => typeof entry === 'string' && entry.trim());
	} catch (e) {
		return [];
	}
}

/** Writes are best-effort: Safari private mode and quota errors are swallowed. */
function writeRecentSearches(list) {
	try {
		window.localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(list));
	} catch (e) {
		/* storage unavailable — recent searches degrade to "off", nothing else breaks */
	}
}

/** onAdd — newest first, case-insensitive dedupe, capped at RECENT_SEARCHES_LIMIT. */
function saveRecentSearch(query) {
	const trimmed = (query || '').trim();
	if (trimmed.length < RECENT_SEARCHES_MIN_LENGTH) return;

	const existing = readRecentSearches().filter(
		(entry) => entry.toLowerCase() !== trimmed.toLowerCase()
	);
	existing.unshift(trimmed);
	writeRecentSearches(existing.slice(0, RECENT_SEARCHES_LIMIT));
}

/** onRemove — single entry, matched case-insensitively. */
function removeRecentSearch(query) {
	const trimmed = (query || '').trim().toLowerCase();
	writeRecentSearches(
		readRecentSearches().filter((entry) => entry.toLowerCase() !== trimmed)
	);
}

/**
 * Capture point. The Algolia app's onSubmit navigates to {root}search?q=…, so the
 * results page is where every entry path converges (Enter key, Algolia's submit, a
 * bookmarked search URL, an inbound link) without depending on any Algolia internals.
 *
 * The save deliberately does NOT happen here on page load: at that moment the hit
 * count is unknown, so a zero-result query gets remembered exactly like a good one.
 * It happens in the search-only stats widget in algolia-hooks.js instead, which is
 * the first place nbHits exists. This file only owns the storage contract.
 *
 * Popular/recent chip clicks still do NOT record — they only refill the input, so
 * they aren't a performed search yet.
 */
window.dpdRecentSearches = {
	save: saveRecentSearch,
	remove: removeRecentSearch,
	minHits: RECENT_SEARCHES_MIN_HITS,
};

/**
 * Handles click on a search suggestion in the Quick Search popup.
 * Prevents default navigation, updates the search input, and triggers a new search.
 * @param {string} query - The search query from the clicked suggestion.
 */
function handleSuggestionClick(query, isMobile) {
  // Target both desktop and mobile Algolia search inputs
  // const input = isMobile ? document.querySelector('.aa-DetachedFormContainer .aa-Input') : document.querySelector('.aa-Input');
  const input = document.querySelector('.aa-Input');
  
  if (!input) {
    console.error('Algolia Quick Search input field not found.');
    return;
  }

  input.value = query;
  // Programmatically trigger an 'input' event to force Algolia Autocomplete to update
  input.dispatchEvent(new Event('input', { bubbles: true }));
}

/**
 * Attaches a capturing event listener to the suggestion list to override
 * default Algolia click behavior. This is more performant and reliable
 * than using MutationObservers to clone nodes.
 * @param {HTMLElement} container - The parent container of the autocomplete panel.
 * @param {boolean} isMobile - Flag to determine which search input to target.
 */
function attachSuggestionClickHandler(container, isMobile) {
    const suggestionList = container.querySelector('[id*="querySuggestionsPlugin-list"]');
    
    // Ensure the listener is attached only once.
    if (suggestionList && !suggestionList.dataset.clickListenerAttached) {
        suggestionList.dataset.clickListenerAttached = 'true';
        
        suggestionList.addEventListener('click', (e) => {
            // By using the capture phase (true), this listener fires before Algolia's.
            // We stop the event from continuing, preventing the default navigation.
            e.preventDefault();
            e.stopPropagation();

            const querySource = e.target.closest('[data-query]');
            if (querySource) {
                handleSuggestionClick(querySource.dataset.query, isMobile);
            }
        }, true); // <-- The 'true' flag enables the capture phase.
    }
}

/* ============================================================================
 * EMPTY-QUERY SUBMIT GUARD
 * Algolia draws the magnifier as a type="submit" button (.aa-SubmitButton — the
 * icon itself is a background-image on that button, with the inner .aa-SubmitIcon
 * set to visibility:hidden in algolia-quick-search.css). So clicking the icon
 * submits the form, and the app's onSubmit navigates to {root}search?q= — a full
 * results page for the empty query. Clicking a search icon is an intent to start
 * searching, not to see zero results, so an empty query focuses the input and
 * leaves the shopper where they are — the icon then behaves exactly like clicking
 * into the field, which on this store opens no panel until a query is typed
 * (MIN_QUERY_LENGTH below gates the panel at 3 characters).
 *
 * Delegated from the document in the capture phase rather than bound to the form:
 * the .aa-Form is owned and re-rendered by the Algolia app embed, so there is no
 * stable node for the theme to hold, and no plugins:/onSubmit array to pass this
 * through (same constraint as the recent-searches plugin above). Registering at
 * parse time means the guard is live before autocomplete ever mounts.
 *
 * The input is resolved from the clicked button's own form, never with a bare
 * document.querySelector('.aa-Input') — under 768px the detached modal's form and
 * the inline header form can both be in the DOM at once, and the bare selector
 * returns whichever comes first (see handleSuggestionClick above for the same
 * hazard). This is also what makes the guard work unchanged inside the detached
 * mobile modal, which renders the same .aa-Form markup.
 *
 * preventDefault() on the button's click is the whole mechanism: it stops the
 * form's submit event from ever firing, so the app's onSubmit never runs. No
 * stopPropagation, deliberately — nothing else in the theme listens for this
 * click, and swallowing it would silently break anything that later does.
 * ========================================================================== */
document.addEventListener(
	'click',
	function (e) {
		const submitButton = e.target.closest?.('.aa-SubmitButton');
		if (!submitButton) return;

		const form = submitButton.closest('.aa-Form') || submitButton.closest('form');
		const input = form?.querySelector('.aa-Input');
		if (!input) return;

		/* Whitespace-only counts as empty — otherwise a stray space submits q=%20. */
		if (input.value.trim()) return;

		e.preventDefault();
		input.focus();
	},
	true
);


document.addEventListener('algolia.hooks.initialize', function () {

  const unsupportedCountries = [
		'AU',
		'BH',
		'CZ',
		'DK',
		'IN',
		'KW',
		'LI',
		'NO',
		'OM',
		'PL',
		'QA',
		'SA',
		'SE',
		'CH',
		'AE',
		'GB',
		'US'
	];

	
	
  algoliaShopify.hooks.registerHook('beforeAutocompleteFiltersString', function(_defaultFilter) {

		// console.log('beforeAutocompleteFiltersString defaultFilter', _defaultFilter);

		let additionalFilter = '';
		
		if(_defaultFilter) {
			additionalFilter = ' AND NOT tags:ghost_product'
		}
		else {
			additionalFilter = 'NOT tags:ghost_product'
		}

		if(
			(Shopify.locale == "fr" && unsupportedCountries.includes(Shopify.country))
			|| (Shopify.country == "CA" && Shopify.locale == "en")
		) {
			additionalFilter = additionalFilter + ' AND NOT tags:do_not_sell_in_canada'		
		}

		return _defaultFilter + additionalFilter;
	});


	// ========================================
	// RECENT SEARCHES PLUGIN
	// A plugin is just an object exposing getSources(), so the recent-searches
	// source can be a first-class autocomplete source without pulling in
	// @algolia/autocomplete-plugin-recent-searches. Being a real source is what
	// earns it the .aa-Source/.aa-List/.aa-Item wrappers (so the existing chip
	// CSS applies as-is), a slot in `elements`, and keyboard navigation.
	// ========================================
	const recentSearchesPlugin = {
		name: 'dpdRecentSearches',
		getSources({ query, refresh }) {
			// Zero-query only: once the shopper types, the left column belongs to
			// live Suggestions + Collections.
			if (query && query.trim()) return [];

			const items = readRecentSearches();
			if (!items.length) return [];

			return [
				{
					sourceId: 'recentSearchesPlugin',
					getItems() {
						return items.map((label) => ({ label }));
					},
					getItemInputValue({ item }) {
						return item.label;
					},
					// No getItemUrl on purpose — that is what keeps selection from
					// navigating. Matches how the Popular Searches chips behave: fill
					// the box and re-run the panel search in place.
					// setQuery + refresh is the API path — the .aa-Input is controlled by
					// autocomplete, so its value follows state.query. Deliberately NOT
					// handleSuggestionClick(): that exists only because the Popular-chip
					// listener runs from raw DOM and has no API access, and its
					// document.querySelector('.aa-Input') grabs the first input on the
					// page, which is the wrong one inside the mobile detached overlay.
					onSelect({ item, setQuery, refresh: refreshOnSelect }) {
						setQuery(item.label);
						refreshOnSelect();
					},
					templates: {
						item({ item, html }) {
							return html`
								<span class="qs-item-link qs-recent-item" data-query="${item.label}">
									<span class="qs-recent-item__label">${item.label}</span>
									<button
										type="button"
										class="qs-recent-item__remove"
										aria-label="${window.algoliaLocales.recent_searches_remove.replace('[query]', item.label)}"
										onClick=${(event) => {
											// The parent .aa-Item carries Algolia's own click
											// handler — without this the ✕ would also fire onSelect.
											event.preventDefault();
											event.stopPropagation();
											removeRecentSearch(item.label);
											refresh();
										}}
									>
										<svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false">
											<line x1="1" y1="1" x2="9" y2="9"></line>
											<line x1="9" y1="1" x2="1" y2="9"></line>
										</svg>
									</button>
								</span>
							`;
						},
					},
				},
			];
		},
	};

	// ⚠️ triggerHooks spreads an array default into separate arguments, so this hook
	// is called as (plugin0, plugin1, …, { algolia }) — NOT (pluginsArray, context).
	// The app's own array legitimately contains falsy entries (e.g. index_articles &&
	// articlesPlugin), so pass them through untouched.
	algoliaShopify.hooks.registerHook('beforeAutocompletePluginsArray', function () {
		const plugins = Array.prototype.slice.call(arguments);
		plugins.pop(); // trailing { algolia } context object
		return [recentSearchesPlugin].concat(plugins);
	});


	algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
		const MIN_QUERY_LENGTH = 3;

		console.log('⚙️ beforeAutocompleteOptions - Incoming:', {
			options: options,
			hasSources: !!options.getSources,
			hasPlugins: !!options.plugins,
			keys: Object.keys(options)
		});

		options = {
			// On mobile, let Algolia handle its own detached experience
			detachedMediaQuery: '(max-width: 767px)',
			...options,
			// Zero-query state: run the sources on focus so the panel shows popular
			// searches + trending products before the shopper types. The empty query is
			// let through explicitly in beforeAutocompleteConfigurationOptions below —
			// without that exception the MIN_QUERY_LENGTH gate blocks it.
			openOnFocus: true,
			placeholder: window.algoliaLocales.search_input_placeholder,
			panelContainer: document.querySelector('#qs-autocomplete-results'),
		}

		console.log('⚙️ beforeAutocompleteOptions - Outgoing:', options);

		return options;
	});


	// ========================================
	// MIN LENGTH + DEBOUNCE: Prevent excessive API calls
	// ========================================
	const MIN_QUERY_LENGTH = 3;
	const DEBOUNCE_MS = 500;
	// Zero-query state only. The typed state keeps products_autocomplete_hits_per_page
	// (24, set in the Algolia app); trimming the empty query keeps the "recommendations
	// on focus" behaviour from costing a 24-hit search on every focus of the input.
	const ZERO_QUERY_HITS_PER_PAGE = 12;

	/* ========================================================================
	 * POPULAR SEARCHES — LANGUAGE SPLIT (ZERO-QUERY STATE ONLY)
	 * Algolia now builds ONE Query Suggestions index per source product index:
	 *   shopify_live_products            → shopify_live_products_query_suggestions
	 *   shopify_live_products_canada_fr  → shopify_live_products_canada_fr_query_suggestions
	 * so the split is settled in the Algolia dashboard and the storefront only has to
	 * ask the right index. Swapping options.indexName per locale is all that remains.
	 *
	 * This replaces a client-side dominance heuristic that read per-source
	 * `exact_nb_hits` sub-objects off a single mixed index and kept a suggestion only
	 * when the active language out-scored the other by a merchant-tuned margin. That
	 * heuristic was always the stopgap — the file said so — and it could not be made
	 * correct: the two product indices are deliberately cross-searchable (bilingual
	 * synonyms, a `multilingual_search` metafield carrying both languages, French
	 * taxonomy tags on English products), so hit counts never cleanly separated the
	 * languages. `tuque` scored higher in English than in French. Per-index builds
	 * remove the guesswork entirely, and the margin setting goes with them.
	 *
	 * The app embed resolves a market+locale index suffix (config.index_suffix) and
	 * applies it to the products and collections queries, but the query-suggestions
	 * plugin awaits that suffix and then discards it — every locale still arrives here
	 * pointed at the English suggestions index. Hence the swap below.
	 *
	 * This is a language map, not a market map: only the CA-EN and CA-FR product
	 * indices have a suggestions index, so US/EU/International EN all read the English
	 * one and a language with no index of its own (de) falls back to English rather
	 * than showing a mix. Adding a third language means adding its suggestions index
	 * here — nothing else in this file needs to change.
	 *
	 * The English index name is NOT hardcoded: an unmapped locale keeps whatever
	 * options.indexName the app embed supplied, so an Algolia-side rename of the
	 * default suggestions index follows through automatically.
	 *
	 * ⚠️ Zero-query only, as before. Once the shopper types, the suggestions are
	 * matches on what they actually wrote and are left alone — though now they come
	 * from the active language's index, so typing "sac" on the English store no longer
	 * returns French completions the way it used to.
	 * ===================================================================== */
	const QS_INDEX_BY_LANGUAGE = {
		fr: 'shopify_live_products_canada_fr_query_suggestions',
	};

	/* Over-fetch so the zero-query exclusion pass can still fill the 8 visible chips.
	 * getSearchParams is static once the plugin is built, so this applies to typed
	 * requests too — hence the unconditional slice back to the configured limit below,
	 * which leaves the typed state byte-identical to hitsPerPage: 8 (same ranking, same
	 * order). QS records are tiny, so the extra payload costs nothing worth optimising.
	 *
	 * Back to 40 from 60. The 60 was headroom for the dominance filter, which discarded
	 * ~60% of the French side; the per-language indices discard nothing, so the only
	 * thinning left is the merchant's exclusion list — a handful of terms. 40 is the
	 * value this ran at before the dominance test existed. */
	const QS_OVER_FETCH = 40;

	/* ========================================================================
	 * PINNED POPULAR SEARCHES (ZERO-QUERY STATE ONLY)
	 * Merchant-curated terms that lead the Popular Searches chips, from
	 * Theme settings → Algolia Search. js-strings.liquid resolves EN/FR before
	 * this file runs, so window.dpdPinnedSearches is always the active
	 * language's list — nothing here branches on locale.
	 *
	 * Done on the theme side rather than in Algolia on purpose. A Query
	 * Suggestions Rule can only reorder records the builder already produced,
	 * so pinning a term that isn't yet popular needs an External Analytics
	 * index *and* a Rule, takes up to 24h to rebuild, and is silently dropped
	 * if the term misses the minimum-results threshold. It also could not be
	 * translated per language until recently, and a Rule still cannot express
	 * "pin this term only when it is already popular enough to be indexed" — which
	 * is exactly what a merchant pinning a term is trying to work around.
	 * ===================================================================== */

	/** Accent- and case-insensitive comparison key. The suggestions index stores
	 * de-accented queries ("sac a dos"), so a merchant typing "Sac à Dos" would
	 * duplicate it without the NFD strip. */
	function normalizeSearchTerm(term) {
		return (term || '')
			.trim()
			.toLowerCase()
			.normalize('NFD')
			.replace(/\p{M}/gu, '');
	}

	/** Trims, drops blanks, and removes terms the merchant listed twice. */
	function readPinnedSearches() {
		const raw = window.dpdPinnedSearches;
		if (!Array.isArray(raw)) return [];

		const seen = new Set();
		return raw
			.map((term) => (term || '').trim())
			.filter((term) => {
				if (!term) return false;
				const key = normalizeSearchTerm(term);
				if (seen.has(key)) return false;
				seen.add(key);
				return true;
			});
	}

	/**
	 * Prepends the pinned terms, drops any Algolia suggestion that duplicates one, and
	 * holds the total at displayLimit so the panel never changes height.
	 *
	 * Pinned terms are synthesised as suggestion records so they travel through the
	 * app's own querySuggestionsPlugin source — that is what earns them the
	 * .aa-Source/.aa-List/.aa-Item wrappers, the existing chip CSS, keyboard
	 * navigation, and the capture-phase click handler, with no extra source to wire up.
	 * They carry no _highlightResult, so the suggestions template renders their query
	 * directly instead of calling components.Highlight (which would read straight
	 * through to undefined and paint an empty chip).
	 */
	function withPinnedSearches(hits, displayLimit) {
		const pinned = readPinnedSearches();
		if (!pinned.length) return hits.slice(0, displayLimit);

		const pinnedKeys = new Set(pinned.map(normalizeSearchTerm));
		const pinnedHits = pinned.map((query) => ({
			objectID: 'dpd-pinned-' + normalizeSearchTerm(query).replace(/\s+/g, '-'),
			query: query,
			__dpdPinned: true,
		}));

		const organic = hits.filter(
			(hit) => !pinnedKeys.has(normalizeSearchTerm(hit.query))
		);

		return pinnedHits.concat(organic).slice(0, displayLimit);
	}

	/* ========================================================================
	 * EXCLUDED POPULAR SEARCHES (ZERO-QUERY STATE ONLY)
	 * Merchant-curated terms that must never appear as Popular Searches chips in the
	 * active language, from Theme settings → Algolia Search. With the per-language
	 * suggestions indices doing the language split, this is no longer a safety net for
	 * a heuristic — it is simply the merchant's veto over terms Algolia ranks highly
	 * but the store does not want on the chips.
	 *
	 * ⚠️ Unlike the pinned lists, the FR list does NOT fall back to the EN list when it
	 * is blank, and that asymmetry is load-bearing. The English exclusion list holds
	 * FRENCH terms ('habit de neige', 'tablier'); falling back to it on the French
	 * storefront would strip exactly the terms French shoppers should be seeing. A blank
	 * FR list therefore means "exclude nothing in French", not "reuse the English list".
	 * js-strings.liquid resolves this, so window.dpdExcludedSearches is always the
	 * active language's list and nothing here branches on locale.
	 *
	 * Pinning wins over excluding. A term in both lists for the same language is a
	 * contradiction, and the pinned list is the more explicit instruction — the merchant
	 * typed that term to make it appear. Exclusion only ever filters Algolia's organic
	 * suggestions.
	 *
	 * ⚠️ No empty-panel guard, on purpose. Excluding everything Algolia returned leaves
	 * the chips empty (bar any pinned terms), because silently restoring terms the
	 * merchant explicitly removed would be worse than an empty block and impossible to
	 * debug from the theme editor.
	 * ===================================================================== */

	/** Trims, drops blanks, and de-dupes the excluded list into comparison keys. */
	function readExcludedSearchKeys() {
		const raw = window.dpdExcludedSearches;
		if (!Array.isArray(raw)) return new Set();

		const keys = new Set();
		raw.forEach((term) => {
			const key = normalizeSearchTerm(term);
			if (key) keys.add(key);
		});
		return keys;
	}

	/** Drops the merchant's excluded terms from Algolia's organic suggestions. Matching
	 * is accent- and case-insensitive via normalizeSearchTerm, so "Habit de Neige" in
	 * the setting removes the index's "habit de neige". */
	function withoutExcludedSearches(hits) {
		const excluded = readExcludedSearchKeys();
		if (!excluded.size) return hits;
		return hits.filter((hit) => !excluded.has(normalizeSearchTerm(hit.query)));
	}

	algoliaShopify.hooks.registerHook('beforeAutocompletePluginOptions', function (options, context) {
		if (context.pluginName !== 'suggestions') return options;

		// Point the suggestions plugin at the active language's index. Unmapped locales
		// keep the app embed's own indexName (English), so this only ever redirects a
		// language that has an index of its own. Done before qsIndex is read: the
		// response filter below matches requests by index name, and it has to match the
		// index actually queried.
		const localeIndex = QS_INDEX_BY_LANGUAGE[window.Shopify.locale];
		if (localeIndex) options.indexName = localeIndex;

		const qsIndex = options.indexName;
		const displayLimit = options.searchParameters.hitsPerPage;

		options.searchParameters.hitsPerPage = QS_OVER_FETCH;

		// Patch the shared searchClient rather than substituting a wrapper object:
		// autocomplete batches requests per searchClient *identity*, so a separate client
		// would split the panel's one multi-query into two round trips. Requests and
		// results are positionally matched by the multi-query API, which is what lets this
		// touch the suggestions query only.
		const client = options.searchClient;
		if (!client.__dpdSuggestionsFilterPatched) {
			client.__dpdSuggestionsFilterPatched = true;
			const originalSearch = client.search.bind(client);
			client.search = function (requests, requestOptions) {
				return originalSearch(requests, requestOptions).then((response) => {
					if (!Array.isArray(requests) || !response || !Array.isArray(response.results)) {
						return response;
					}
					response.results.forEach((result, i) => {
						const request = requests[i];
						if (!request || request.indexName !== qsIndex) return;
						if (!result || !Array.isArray(result.hits)) return;

						// The requester flattens params onto the request, but read both
						// shapes so this survives either.
						const query = request.query || (request.params && request.params.query) || '';
						const isZeroQuery = !query.trim();

						// Pinning happens here rather than in a transformSource so the
						// "how many chips" contract stays in one place — the over-fetch
						// above and this slice are the same decision.
						result.hits = isZeroQuery
							? withPinnedSearches(
									withoutExcludedSearches(result.hits),
									displayLimit
								)
							: result.hits.slice(0, displayLimit);
					});
					return response;
				});
			};
		}

		return options;
	});

	let lastQuery = '';
	let lastInputTime = 0;
	let queryCount = 0;
	let debounceTimer = null;
	let shouldAllowSearch = true; // Start as true

	// Update search warning message
	// function updateSearchWarning(query) {
	// 	const shouldShowWarning = query.length > 0 && query.trim().length < MIN_QUERY_LENGTH;
		
	// 	// === DESKTOP ===
	// 	const desktopWarning = document.getElementById('qs-min-length-warning');
	// 	const desktopResults = document.getElementById('qs-autocomplete-results');
		
	// 	if (desktopWarning) {
	// 		if (shouldShowWarning) {
	// 			desktopWarning.style.display = 'flex';
	// 			if (desktopResults) desktopResults.style.display = 'none';
	// 		} else {
	// 			desktopWarning.style.display = 'none';
	// 			if (desktopResults) desktopResults.style.display = 'block';
	// 		}
	// 	}
		
	// 	// === MOBILE (Detached Modal) ===
	// 	const mobileOverlay = document.querySelector('.aa-DetachedOverlay');
	// 	if (mobileOverlay) {
	// 		const formContainer = mobileOverlay.querySelector('.aa-DetachedFormContainer');
	// 		const mobilePanel = mobileOverlay.querySelector('.aa-Panel');
			
	// 		if (formContainer) {
	// 			// Check if warning already exists AFTER form container (as sibling)
	// 			let mobileWarning = formContainer.nextElementSibling;
	// 			if (!mobileWarning || !mobileWarning.classList.contains('qs-min-length-warning')) {
	// 				mobileWarning = null;
	// 			}
				
	// 			// If not, clone from desktop and insert AFTER form container
	// 			if (!mobileWarning && desktopWarning) {
	// 				mobileWarning = desktopWarning.cloneNode(true);
	// 				mobileWarning.id = 'qs-min-length-warning-mobile'; // Different ID for mobile
	// 				// Insert AFTER formContainer (as sibling)
	// 				formContainer.insertAdjacentElement('afterend', mobileWarning);
	// 			}
				
	// 			// Show/hide warning and results on mobile
	// 			if (mobileWarning) {
	// 				if (shouldShowWarning) {
	// 					mobileWarning.style.display = 'flex';
	// 					if (mobilePanel) mobilePanel.style.display = 'none';
	// 				} else {
	// 					mobileWarning.style.display = 'none';
	// 					if (mobilePanel) mobilePanel.style.display = 'block';
	// 				}
	// 			}
	// 		}
	// 	}
	// }

	// Force autocomplete to re-evaluate by triggering input event
	function triggerAutocompleteRefresh() {
		const input = document.querySelector('.aa-Input');
		if (input) {
			// Trigger a custom event that Algolia listens to
			const event = new Event('input', { bubbles: true });
			input.dispatchEvent(event);
			console.log('🔄 Triggered autocomplete refresh');
		}
	}

	// This hook runs on EVERY KEYSTROKE before any search query is executed
	algoliaShopify.hooks.registerHook('beforeAutocompleteConfigurationOptions', function(config, context) {
		const query = config.queries[0]?.query || '';
		const now = Date.now();
		queryCount++;

		// Update warning
		// updateSearchWarning(query);

		// ========================================
		// ZERO-QUERY STATE (openOnFocus)
		// An empty query is not a "too short" query — it is the on-focus state, and it
		// must bypass both the MIN_QUERY_LENGTH gate and the debounce so the panel
		// paints immediately on focus. Algolia returns the top of the index for an
		// empty query, which is what makes it read as recommendations.
		// ========================================
		if (query.trim().length === 0) {
			if (debounceTimer) {
				clearTimeout(debounceTimer);
				debounceTimer = null;
			}
			lastQuery = query;
			shouldAllowSearch = true;

			if (context.sourceId === 'products' && config.queries[0]?.params) {
				config.queries[0].params.hitsPerPage = ZERO_QUERY_HITS_PER_PAGE;
			}

			console.log(`🎯 [${queryCount}] ${context.sourceId}: zero-query state - ALLOW`);
			return config;
		}

		// If query changed, start debounce
		if (query !== lastQuery) {
			lastQuery = query;
			lastInputTime = now;
			
			// Clear previous timer
			if (debounceTimer) {
				clearTimeout(debounceTimer);
			}

			const queryLength = query.trim().length;
			
			// If query is too short, block immediately
			if (queryLength < MIN_QUERY_LENGTH) {
				shouldAllowSearch = false;
				console.log(`📝 Query "${query}" too short - BLOCKING`);
			} else {
				// Query is valid length, start debounce
				shouldAllowSearch = false;
				console.log(`📝 Query "${query}" changed - starting ${DEBOUNCE_MS}ms debounce`);
				
				debounceTimer = setTimeout(function() {
					shouldAllowSearch = true;
					console.log(`✅ Debounce complete - triggering search for "${query}"`);
					triggerAutocompleteRefresh();
				}, DEBOUNCE_MS);
			}
		}

		console.log(`🔄 [${queryCount}] ${context.sourceId}: "${query}" (${query.trim().length} chars) - ${shouldAllowSearch ? 'ALLOW' : 'BLOCK'}`);

		// Return proper config if allowed, empty object if blocked
		if (shouldAllowSearch) {
			return config;
		} else {
			return {};
		}
	});
  

	// Product template hook - reusing search page product card
	algoliaShopify.hooks.registerHook('beforeAutocompleteProductTemplate', function(_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
		const { html, item: hit, components } = templateOptions;

    // console.log('QUICK SEARCH HIT', hit);
		// All the HTML generation is now in the helper
		return window.algoliaProductHelpers.createProductCardHTML(hit, {
			html,
			components,
			itemLink,
			trackSearchAttribution,
		}, 'autocomplete');
	});

    
  // Custom hook for two-column autocomplete layout
  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
      const { html, state } = templateOptions;

      // console.log('ELEMENTS', elements);

      // Zero-query (openOnFocus) state: the sources ran with an empty query, so the
      // suggestions are the index's most popular searches and the products are the top
      // of the index — recommendations rather than results. Collections are dropped
      // here: an empty query against the collections index returns operational junk
      // ("In Stock", "All", "SELECTED ALL PRODUCTS") rather than anything shoppable.
      const isZeroQuery = !state.query || !state.query.trim();

      const seeAllHref = isZeroQuery
        ? `${window.Shopify.routes.root}collections/all`
        : `${window.Shopify.routes.root}search?q=${encodeURIComponent(state.query)}`;

      // Return custom two-column layout with cleaner class names
      return html`
          <div class="qs-panel-left ${isZeroQuery ? 'qs-panel-left--zero-query' : ''}">
              <!-- Recent searches sit above Popular. elements.recentSearchesPlugin is
                   undefined whenever the source returns no items, so removing the last
                   chip tears the whole block (heading included) down on its own. -->
              ${isZeroQuery && elements.recentSearchesPlugin && html`
                  <div class="qs-source qs-source--recent">
                      <span class="qs-section-header">
                          ${window.algoliaLocales.recent_searches}
                      </span>
                      ${elements.recentSearchesPlugin}
                  </div>
              `}

              ${displaySuggestions && html`
                  <div class="qs-source">
                      <span class="qs-section-header">
                          ${isZeroQuery
                            ? window.algoliaLocales.popular_searches
                            : algoliaShopify.translations.suggestions}
                      </span>
                      ${elements.querySuggestionsPlugin}
                  </div>
              `}

              ${!isZeroQuery && html`
                <div class="qs-source">
                    <span class="qs-section-header">
                        ${algoliaShopify.translations.collections}
                    </span>
                    ${elements.collections}
                </div>
              `}
                <!-- ${elements.redirectUrlPlugin} -->
            </div>

          <div class="qs-panel-right ${isZeroQuery ? 'qs-panel-right--zero-query' : ''}">
              ${isZeroQuery && html`
                <span class="qs-section-header qs-section-header--products">
                    ${window.algoliaLocales.trending_now}
                </span>
              `}

              ${elements.products}

              <div class="qs-footer">
                <a
                  class="qs-see-all-btn"
                  href="${seeAllHref}"
                >
                  ${algoliaShopify.translations.allProducts} (${algoliaShopify.helpers.formatNumber(state.context.nbProducts)})
                </a>
              </div>
          </div>
      `;
  });


  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    const { html } = templateOptions;
    return html`

    `;
  });

  
  algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`

    `;
  });


  algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="qs-no-results">
        <div class="qs-no-results__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="11"></line><line x1="11" y1="14" x2="11.01" y2="14"></line></svg>
        </div>
        <p class="qs-no-results__message">
          ${window.algoliaLocales.no_results.replace('[query]', `"${state.query}"`)}
        </p>
      </div>
    `;
  });


  algoliaShopify.hooks.registerHook('beforeAutocompleteCollectionsTemplate', function(_defaultTemplate, templateOptions, itemLink) {
      const { html, item, components } = templateOptions;

      // console.log('COLLECTIONS ITEM QUICK SEARCH', item);

        if (item.products_count < 1) {
          return html``;
        }
        return  html`
            <a href="${itemLink}" class="qs-item-link">
                ${components.Highlight({ hit: item, attribute: 'title' })}
            </a>
        `;
    });
    
    algoliaShopify.hooks.registerHook('beforeAutocompleteSuggestionsTemplate', function(_defaultTemplate, templateOptions) {
        const { html, item, components } = templateOptions;

      // console.log('SUGGESTIONS TEMPLATE', templateOptions);
      
      // Pinned chips carry no _highlightResult, so components.Highlight would read
      // through to undefined and paint an empty chip. Nothing is lost by skipping it:
      // pinned terms only ever render in the zero-query state, where there is no query
      // to highlight. data-query is what the capture-phase click handler reads, so it
      // stays on both kinds of chip.
      return html`
          <span
            class="qs-item-link suggestion-button${item.__dpdPinned ? ' suggestion-button--pinned' : ''}"
            data-query="${item.query}"
          >
              ${item.__dpdPinned
                ? item.query
                : components.Highlight({ hit: item, attribute: 'query' })}
          </span>
      `;
  });


  console.log('Algolia Quick Search initialized');

  /**
   * Desktop inline results (no <dialog>): mirror open/close side effects from AlgoliaSearchDialog
   * when #qs-autocomplete-results gains or loses .aa-Item nodes.
   */
  let desktopQuickSearchOverlayOpen = false;
  const quickSearchAnnouncementSection =
    document.querySelector('.shopify-section.promo-bar-section') ||
    document.querySelector('.shopify-section.announcement-bar-section') ||
    document.querySelector('.utility-bar-section');

  function syncQuickSearchResultsHeight() {
    const wrapper = document.getElementById('qs-autocomplete-results');
    if (!wrapper) return;
    const offset = Math.max(0, Math.round(wrapper.getBoundingClientRect().top));
    document.documentElement.style.setProperty(
      '--qs-header-with-announcement',
      offset + 'px'
    );
  }

  function openDesktopQuickSearchOverlay() {
    if (desktopQuickSearchOverlayOpen || window.innerWidth < 768) return;

    // The scroll past the announcement bar must be instant and complete
    // before the scroll lock below — a smooth scroll gets cancelled by the
    // lock and leaves the bar on screen, shifting the results down.
    const announcementHeight = quickSearchAnnouncementSection?.offsetHeight || 0;
    const scrollTop = document.scrollingElement?.scrollTop || 0;
    if (scrollTop < announcementHeight) {
      try {
        window.scrollTo({ top: announcementHeight, behavior: 'instant' });
      } catch (e) {
        window.scrollTo(0, announcementHeight);
      }
    }

    document.body.classList.add('overflow-hidden', 'SearchModalActive');
    desktopQuickSearchOverlayOpen = true;
    syncQuickSearchResultsHeight();
    requestAnimationFrame(syncQuickSearchResultsHeight);
    setTimeout(syncQuickSearchResultsHeight, 350);
    window.addEventListener('resize', syncQuickSearchResultsHeight);
  }

  function closeDesktopQuickSearchOverlay() {
    if (!desktopQuickSearchOverlayOpen) return;

    document.body.classList.remove('overflow-hidden', 'SearchModalActive');
    desktopQuickSearchOverlayOpen = false;
    window.removeEventListener('resize', syncQuickSearchResultsHeight);
  }

  // function ensureDesktopQuickSearchDismissListeners() {
  //   if (ensureDesktopQuickSearchDismissListeners.done) return;
  //   ensureDesktopQuickSearchDismissListeners.done = true;

  //   document.addEventListener('keydown', (e) => {
  //     if (e.key !== 'Escape') return;
  //     if (!desktopQuickSearchOverlayOpen || window.innerWidth < 768) return;
  //     e.preventDefault();
  //     closeDesktopQuickSearchOverlay();
  //     const input = document.querySelector(
  //       '#qs-autocomplete-form input[type="search"], #qs-autocomplete-form .aa-Input'
  //     );
  //     input?.blur();
  //   });
  // }
  
  // --- Helper function for dynamic mobile layout ---
  function applyMobileScrollLayout(panelSelector) {
    if (window.innerWidth >= 768) return; // Only run on mobile

    const sources = document.querySelectorAll(`${panelSelector} .qs-source`);
    sources.forEach(source => {
      const list = source.querySelector('.aa-List');
      if (!list || !list.firstElementChild) return;

      // Reset first to measure natural height
      if (source.classList.contains('is-horizontally-scrollable')) {
        source.classList.remove('is-horizontally-scrollable');
      }

      const firstItem = list.firstElementChild;
    //   const itemStyles = window.getComputedStyle(firstItem);
      const itemHeight = firstItem.offsetHeight + 5;
      const twoLinesHeight = itemHeight * 2;

      if (list.scrollHeight > twoLinesHeight) {
        source.classList.add('is-horizontally-scrollable');
      }
    });
  }

  /**
   * Creates a MutationObserver for a given panel (desktop or mobile) to handle
   * dynamic content changes, such as fetching extra data and attaching event listeners.
   * This is a reusable function to avoid code duplication.
   * @param {HTMLElement} panelElement - The autocomplete panel to observe.
   * @param {boolean} isMobile - A flag to indicate if it's the mobile view.
   */
  function setupPanelObserver(panelElement, isMobile) {
    // ensureDesktopQuickSearchDismissListeners();

    const observer = new MutationObserver(async (mutations, obs) => {
        const hasContent = panelElement.querySelector('.aa-Item');

        if (!isMobile) {
          if (hasContent) {
            openDesktopQuickSearchOverlay();
          } else {
            closeDesktopQuickSearchOverlay();
          }
        }

        if (!hasContent) {
          return;
        }

        obs.disconnect();

        const panelSelector = isMobile ? '.aa-DetachedOverlay' : '#qs-autocomplete-results';

        if (window.algoliaProductHelpers && panelElement.querySelector('.ais-product')) {
            // await window.algoliaProductHelpers.fetchAdditionalProductData(panelSelector);
        }

        attachSuggestionClickHandler(panelElement, isMobile);

        if (isMobile) {
            applyMobileScrollLayout(panelSelector);
        }

        obs.observe(panelElement, { childList: true, subtree: true });
    });

    observer.observe(panelElement, { childList: true, subtree: true });
  }

  // --- Setup observer for the main desktop panel ---
  const resultsWrapper = document.getElementById('qs-autocomplete-results');
  if (resultsWrapper) {
      setupPanelObserver(resultsWrapper, false);
  }

  const scrollLockElems = document.querySelectorAll('body, html, #MainContent');

  // --- Setup a MutationObserver to detect when the mobile panel is added/removed ---
  const bodyObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Check for ADDED nodes (overlay opened)
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.matches('.aa-DetachedOverlay')) {
            // Mobile panel opened - lock scroll on both html and body (iOS fix)
            scrollLockElems.forEach(element => {
              element.classList.add('algolia-mobile-overlay-active');
              element.dataset.lastScrollTop = element.scrollTop;

              setTimeout(() => {
                element.scrollTop = 0;
              }, 100);
            });
            console.log('🔒 Mobile overlay opened - scroll locked');
            
            // Set up the panel observer
            setupPanelObserver(node, true);
          }
        }
        
        // Check for REMOVED nodes (overlay closed)
        for (const node of mutation.removedNodes) {
          if (node.nodeType === 1 && node.matches('.aa-DetachedOverlay')) {
            // Mobile panel closed - unlock scroll
            scrollLockElems.forEach(element => {
              element.classList.remove('algolia-mobile-overlay-active');

              setTimeout(() => {
                element.scrollTop = element.dataset.lastScrollTop;
                delete element.dataset.lastScrollTop;
              }, 100);
            });
            
            console.log('🔓 Mobile overlay closed - scroll unlocked');
          }
        }
      }
    }
  });

  // Keep observing the body to detect both add and remove events
  bodyObserver.observe(document.body, { childList: true });
});




// class AlgoliaSearchDialog extends HTMLElement {
//   constructor() {
//     super();
    
//     this.isOpen = false;
//     this.dialog = this.querySelector('.algolia-dialog');
//     this.closeButton = this.querySelector('.algolia-dialog__close');
//     this.popupId = this.dataset.popupId;
//     this.activeTrigger = null;
//     this.isInitialized = false;
//     this.announcementSection = document.querySelector('.shopify-section.announcement-bar-section');
    
//     this.init();
//   }

//   init() {
//     if (this.isInitialized) return; // Prevent multiple initializations
    
//     // Handle close button click
//     if (this.closeButton) {
//       this.closeButton.addEventListener('click', (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         this.closeModal();
//       });
//     }

//     // Handle backdrop click
//     if (this.dialog) {
//       this.dialog.addEventListener('click', (e) => {
//         if (e.target === e.currentTarget) {
//           e.preventDefault();
//           e.stopPropagation();
//           this.closeModal();
//         }
//       });
//     }

//     // Handle escape key
//     this.escapeHandler = (e) => {
//       if (e.key === 'Escape' && this.isOpen) {
//         e.preventDefault();
//         this.closeModal();
//       }
//     };
//     document.addEventListener('keydown', this.escapeHandler);

//     // Use event delegation for trigger clicks
//     this.setupEventDelegation();
    
//     this.isInitialized = true;
//   }

//   setupEventDelegation() {
//     // Single document click listener for all trigger buttons
//     this.triggerClickHandler = (e) => {
//       const trigger = e.target.closest(`[data-search-popup="${this.popupId}"]`);
      
//       if (trigger) {
//         e.preventDefault();
//         e.stopPropagation();

//         // On mobile, instead of opening our dialog, we find the hidden Algolia button and click it
//         if (window.innerWidth < 768) {
//           // This is the button Algolia's script uses to open the detached search
//           const algoliaMobileTrigger = document.querySelector('.aa-DetachedSearchButton');
//           if (algoliaMobileTrigger) {
//             algoliaMobileTrigger.click();
//           }
//           return; // Stop further execution for mobile
//         }
        
//         if (this.isOpen && this.activeTrigger === trigger) {
//           // If clicking the same trigger that opened the dialog, close it
//           this.closeModal();
//         } else {
//           // Open dialog and track which trigger opened it
//           this.activeTrigger = trigger;
//           this.openModal();
//         }
//         return;
//       }
      
//       // Check if click is outside the dialog to close it
//       if (this.isOpen) {
//         const dialogContent = this.dialog.querySelector('.algolia-dialog__content');
//         const isInsideDialog = dialogContent && dialogContent.contains(e.target);
//         const isInsideAlgoliaDropdown = e.target.closest('.aa-Panel, .aa-DetachedOverlay');
        
//         if (!isInsideDialog && !isInsideAlgoliaDropdown) {
//           this.closeModal();
//         }
//       }
//     };
    
//     document.addEventListener('click', this.triggerClickHandler);
//   }

//   openModal() {
//     if (this.isOpen) return;

//     // Do not open custom dialog on mobile, as Algolia's detached view is used instead
//     if (window.innerWidth < 768) {
//       return;
//     }

//     // Handle announcement section scroll
//     const announcementSectionHeight = this.announcementSection?.offsetHeight || 0;
//     const scrollTop = document.scrollingElement.scrollTop || 0;

//     if (scrollTop < announcementSectionHeight) {
//       window.scrollTo({
//         top: announcementSectionHeight,
//         behavior: 'smooth'
//       });
//     }
    
//     document.body.classList.add('overflow-hidden');
//     document.body.classList.add('SearchModalActive');
//     this.dialog.showModal();
//     this.isOpen = true;
    
//     // Add active state to current trigger
//     if (this.activeTrigger) {
//       this.activeTrigger.classList.add('is-active');
//     }
    
//     // Focus the Algolia search input if it exists
//     setTimeout(() => {
//       const algoliaInput = this.querySelector('.aa-Input');
//       if (algoliaInput) {
//         algoliaInput.focus();
//       }
//     }, 100);
//   }

//   closeModal() {
//     if (!this.isOpen) return;
    
//     this.dialog.classList.add('animate-close');
//     this.isOpen = false;

//     // Remove active state from all triggers
//     const triggers = document.querySelectorAll(`[data-search-popup="${this.popupId}"]`);
//     triggers.forEach(trigger => {
//       trigger.classList.remove('is-active');
//     });
    
//     this.activeTrigger = null;

//     setTimeout(() => {
//       document.body.classList.remove('overflow-hidden');
//       document.body.classList.remove('SearchModalActive');
//       this.dialog.close();
//       this.dialog.classList.remove('animate-close');
      
//       // Clear Algolia search if needed
//       const algoliaInput = this.querySelector('.aa-Input');
//       if (algoliaInput) {
//         algoliaInput.value = '';
//       }
//     }, 200);
//   }

//   connectedCallback() {
//     // Only setup if not already initialized
//     if (!this.isInitialized) {
//       this.init();
//     }
//   }

//   disconnectedCallback() {
//     // Clean up all event listeners when element is removed
//     if (this.triggerClickHandler) {
//       document.removeEventListener('click', this.triggerClickHandler);
//     }
    
//     if (this.escapeHandler) {
//       document.removeEventListener('keydown', this.escapeHandler);
//     }
    
//     this.isInitialized = false;
//   }
// }
  
// if (!customElements.get('algolia-search-dialog')) {
//   customElements.define('algolia-search-dialog', AlgoliaSearchDialog);
// }
  